import { Component, OnInit } from '@angular/core';
import { Globals } from '@app/shared/globals/globals';

@Component({
  selector: 'app-feature-locked',
  templateUrl: './feature-locked.component.html',
  styleUrls: ['./feature-locked.component.css']
})
export class FeatureLockedComponent implements OnInit {

  constructor(public globals: Globals) { }

  ngOnInit() {
  }

}
